<!-- 热门专利，热门商标等通用tab商品展示 -->
<template>
	<div class="popular_tab">
		<div class="hot_title d-flex">
			<!-- 左侧标题及描述 -->
			<div class="left_title">
				<span class="titleName">{{titleName}}</span>
				<span class="titleEngName">{{titleEngName}}</span>
			</div>
			<!-- 右侧更多按钮 -->
			<div class="right_More">
				<span @click="goDetail">更多 >></span>
			</div>
		</div>
		<!-- 下方内容插槽 -->
		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			titleName: {
				type: String,
				default:''
			},
			titleEngName:{
				type: String,
				default:''
			},
			moreLinkUrl:{
				type: String,
				default:'#'
			},
			type:{
				type:String,
				default:''
			}
		},
		methods: {
			goDetail() {
				let routeData = this.$router.resolve({
					path:this.moreLinkUrl,
					query:{
						type:this.type
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	.popular_tab{
		width: 1200px;
		margin: 0 auto;
	}
	.hot_title{
		height:50px;
		border-bottom: 1px solid #ccc;
		justify-content: space-between;
	}
	.hot_title .left_title{
		line-height: 50px;
	}
	
	.hot_title .right_More{
		line-height:60px;
	}
	.hot_title .right_More span:hover{
		cursor: pointer;
		color: #C32A1A;
	}
	.hot_title .left_title .titleName{
	    display: inline-block;
	    height: 45px;
	    position: relative;
	    font-size: 24px;
	    color: #333;
	    line-height: 48px;
	}
	.hot_title .left_title .titleEngName{
		padding-left:30px;
		color: #999;
	}
	.right_More a{
		color:#333;
	}
	.right_More a:hover{
		color:#c32a1a;
	}
</style>
